import {Route} from 'entity-manager';

export enum CalendarEntryItemTypeEnum {
    Overtime = 'overtime',
    AbsenceTime = 'absenceTime'
}

@Route('calendar_entry_item_types')
export class CalendarEntryItemType {

    protected id: string;
    protected code: CalendarEntryItemTypeEnum;
    protected color: string;
    protected name: string;
    protected description: string;

    public setId(id: string) {
        this.id = id;
        return this;
    }

    public getId(): string {
        return this.id;
    }

    public setCode(code: CalendarEntryItemTypeEnum) {
        this.code = code;
        return this;
    }

    public getCode(): string {
        return this.code;
    }

    public setName(name: string) {
        this.name = name;
        return this;
    }

    public getName(): string {
        return this.name;
    }

    public setDescription(description: string) {
        this.description = description;
        return this;
    }

    public getDescription(): string {
        return this.description;
    }
}
